'use strict';

module.exports = /* @ngInject */ function($scope, $timeout, $filter, sbeStorageService, sbeStorageArticleService) {
	/**
	 * init controller mit supplier index
	 * @param  {string} supplier_company_id
	 */
	$scope.init = function(supplier_company_id) {

		$scope.supplier_company_id = supplier_company_id;

		$scope.location = {
				current: {},
				form : {}
			};
		$scope.warehouse = {
				current: {}, 
				form: {}
			};
		$scope.storageplace = {
				current: {},
				form: {}
			};

		$scope.storageplaces = [];
      	
		// load locations
		$scope.getLocations();
	};

	/**
	 * edit / create form anzeigen
	 * @param  {string} mode edit,create
	 */
	function startForm(mode) {
		$scope.formMode = mode;
		$scope.showForm = true; 
	}

	/**
	 * edit create form ausblenden
	 */
	function stopForm() {
		$scope.showForm = false;
	}
	

	/**
	 * create location form initialisieren und anzeigen
	 */
	$scope.createLocationForm = function() {
		$scope.location.form = {supplierCompany: $scope.supplier_company_id};
		startForm('create');
	};

	/**
	 * create warehouse form initialisieren und anzeigen
	 */
	$scope.createWarehouseForm = function() {
		$scope.warehouse.form = {locationId: $scope.location.current.id};
		startForm('create');
	}; 

	/**
	 * create storageplace form initialisieren und anzeigen
	 */
	$scope.createStorageplaceForm = function() {
		$scope.storageplace.form = {warehouseId: $scope.warehouse.current.id};
		startForm('create');
	}; 

	/**
	 * edit location form initialisieren und anzeigen
	 */
	$scope.editLocationForm = function(location) {
		$scope.location.form = location;
		startForm('edit');
	};

	/**
	 * edit warehouse form initialisieren und anzeigen
	 */
	$scope.editWarehouseForm = function(warehouse) {
		$scope.warehouse.form = warehouse;
		startForm('edit');
	};

	/**
	 * edit storageplace form initialisieren und anzeigen
	 */
	$scope.editStorageplaceForm = function(storageplace) {
		$scope.storageplace.form = storageplace;
		startForm('edit');
	};

	/**
	 * prüfen ob code in warehouseliste enthalten ist
	 * @param  {array} data Array mit Daten aus location, warehouse, storageplace
	 * @param  {string} code String, welche in Array nicht enthalten sein darf
	 * @return {boolean}      true, wenn code noch nicht vergeben ist
	 */
	function checkCode(data, code) {
		var found = $filter('filter')(data, {code: code}, true);	
		return found.length === 0;
	}

	/**
	 * alle locations ziehen
	 */
	$scope.getLocations = function () {
		$scope.location.current = {}; 
		$scope.promise = sbeStorageService.location.query({supplier_company_id:$scope.supplier_company_id}).$promise.then(
			//success
			function(data) {
				$scope.locations = data;
				stopForm()
			},
			//error
			sbeStorageService.error
		);
	};

	/**
	 * neue location anlegen
	 */
	$scope.createLocation = function() {
		if(!checkCode($scope.locations, $scope.location.form.code)) {
			growl(gettxt.form.keyAlreadyAvailable, 1);
		} else {
			$scope.promise = sbeStorageService.location.create($scope.location.form).$promise.then(
				//success
				function(data) {
					growl(gettxt.form.createSuccess);
					$scope.getLocations();
				},
				//error
				sbeStorageService.error
			);
		};
	};

	/**
	 * location aktualisieren
	 */
	$scope.saveLocation = function() { 
		$scope.promise = sbeStorageService.location.update(
				{
					location_id: $scope.location.form.id
				},
				$scope.location.form)
			.$promise.then(
				//success
				function(data) {
					growl(gettxt.form.updateSuccess);
					$scope.getLocations();
				},
				// error
				sbeStorageService.error
			);
	};

	/**
	 * location löschen
	 */
	$scope.deleteLocation = function(location) { 
		if(confirm(gettxt.form.deleteConfirm)) {
			$scope.promise = sbeStorageService.location.delete(
					{
						location_id: location.id
					})
				.$promise.then(
					//success
					function(data) {
						growl(gettxt.form.deleteSuccess);
						$scope.getLocations();
					},
					//error
					sbeStorageService.error
				);
		};
	};

	/**
	 * alle warehouses ziehen
	 */
	$scope.getWarehouses = function (location) {
		$scope.warehouse.current = {};
		$scope.storageplaces = [];
		
		if(typeof location != 'undefined')
			$scope.location.current = location;

		$scope.promise = sbeStorageService.warehouse.query({location_id: $scope.location.current.id}).$promise.then(
			//success
			function(data) {
				$scope.warehouses = data;
				stopForm()
			},
			//error
			sbeStorageService.error
		);
	};

	/**
	 * warehouse anlegen
	 */
	$scope.createWarehouse = function() {
		
		if(!checkCode($scope.warehouses, $scope.warehouse.form.code)) {
			growl(gettxt.form.keyAlreadyAvailable, 1);
		} else {
			$scope.promise = sbeStorageService.warehouse.create($scope.warehouse.form).$promise.then(
				//success
				function(data) {
					growl(gettxt.form.createSuccess);
					$scope.getWarehouses();
				},
				//error
				sbeStorageService.error
			);
		};
	};

	/**
	 * warehouse speichern
	 */
	$scope.saveWarehouse = function() { 
		$scope.promise = sbeStorageService.warehouse.update(
				{
					warehouse_id: $scope.warehouse.form.id
				},
				$scope.warehouse.form)
			.$promise.then(
				//success
				function(data) {
					growl(gettxt.form.updateSuccess);
					$scope.getWarehouses();
				},
				//error
				sbeStorageService.error
			);
	};

	/**
	 * warehouse löschen
	 */
	$scope.deleteWarehouse = function(warehouse) { 
		if(confirm(gettxt.form.deleteConfirm)) {
			$scope.promise = sbeStorageService.warehouse.delete(
					{
						warehouse_id: warehouse.id
					})
				.$promise.then(
					//success
					function(data) {
						growl(gettxt.form.deleteSuccess);
						$scope.getWarehouses();
					},
					//error
					sbeStorageService.error
				);
		};
	};

	/**
	 * alle storageplaces ziehen
	 */
	$scope.getStorageplaces = function (warehouse) {

		if(typeof warehouse != 'undefined')
			$scope.warehouse.current = warehouse;

		$scope.promise = sbeStorageService.storageplace.query({warehouse_id: $scope.warehouse.current.id}).$promise.then(
			//success
			function(data) {
				$scope.storageplaces = data;

				angular.forEach($scope.storageplaces, function (item) {
					sbeStorageArticleService.inventory.query(
						{
							storage_place_id: item.id
						})
						.$promise.then(
						//success
						function(articleList) {
							item.assignedArticles = articleList;
						},
						//error
						sbeStorageArticleService.error
					);
				});
				stopForm();
			},
			//error
			sbeStorageService.error
		);
	};



	/**
	 * storageplace anlegen
	 */
	$scope.createStorageplace = function() {
		if(!checkCode($scope.storageplaces, $scope.storageplace.form.code)) {
			growl(gettxt.form.keyAlreadyAvailable, 1);
		} else {
			$scope.promise = sbeStorageService.storageplace.create($scope.storageplace.form).$promise.then(
				//success
				function(data) {
					growl(gettxt.form.createSuccess);
					$scope.getStorageplaces();
				},
				//error
				sbeStorageService.error
			);
		};
	};

	/**
	 * storageplace speichern
	 */
	$scope.saveStorageplace = function() { 
		$scope.promise = sbeStorageService.storageplace.update(
				{
					storageplace_id: $scope.storageplace.form.id
				},
				$scope.storageplace.form)
			.$promise.then(
				//success
				function(data) {
					growl(gettxt.form.updateSuccess);
					$scope.getStorageplaces();
				},
				//error
				sbeStorageService.error
			);
	};

	/**
	 * storageplace löschen
	 */
	$scope.deleteStorageplace = function(storageplace) {
		if(confirm(gettxt.form.deleteConfirm)) {
			$scope.promise = sbeStorageService.storageplace.delete(
					{
						storageplace_id: storageplace.id
					})
				.$promise.then(
					//success
					function(data) {
						growl(gettxt.form.deleteSuccess);
						$scope.getStorageplaces();
					},
					//error
					sbeStorageService.error
				);
		};
	};

};
